import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as workspace from '../workspace'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: workspace.RESOURCE.payload.dimension.partialId,
      partialId: workspace.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: [],
    description:
      'List of user IDs that have been granted access to this workspace.',
    isOptional: true,
    name: 'Shared With',
    partialId: PartialId.Standard.create('shared_with'),
    type: core.common.value.types.Intrinsic.List,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
